import { CapacitorHttp, HttpOptions, HttpResponse } from "@capacitor/core";
import baseHttpOptions from "../../util/http-common";

const getArticlesProductPriceAvail = async () => {

    const options: HttpOptions = baseHttpOptions("indexproductpriceavail");

    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}

const getArticlesOverview = async () => {
    const options: HttpOptions = baseHttpOptions("overview");

    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}

const getArticlesCuttingParamsStd = async () => {
    const options: HttpOptions = baseHttpOptions("cuttingparamsstd");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}

const getArticlesCuttingParamsStdTimestamp = async () => {
    const options: HttpOptions = baseHttpOptions("cuttingparamsstdtimestamp");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return {articlesCuttingParamsStd: data};
}

const getArticlesCuttingParamsTro = async () => {
    const options: HttpOptions = baseHttpOptions("cuttingparamstro");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}

const getArticlesCuttingParamsTroTimestamp = async () => {
    const options: HttpOptions = baseHttpOptions("cuttingparamstrotimestamp");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return {articlesCuttingParamsTro: data};
}

const getArticleSpecs = async () => {
    const options: HttpOptions = baseHttpOptions("v2/indexproductspecs");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}

const getArticleCuttingsSpecsStd = async () =>{
    const options: HttpOptions = baseHttpOptions("cuttingspecsstd");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}

const getArticleCuttingsSpecsTro = async () =>{
    const options: HttpOptions = baseHttpOptions("cuttingspecstro");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}



const ArticleService = {
    getArticles: getArticlesProductPriceAvail,
    getArticlesOverview,
    getArticlesCuttingParamsStd,
    getArticlesCuttingParamsStdTimestamp,
    getArticlesCuttingParamsTro,
    getArticlesCuttingParamsTroTimestamp,
    getArticleSpecs,
    getArticleCuttingsSpecsStd,
    getArticleCuttingsSpecsTro
}

export default ArticleService;